import ClipLoader from "react-spinners/ClipLoader";
import { colors } from "../../theme";

const Loader = (props) => {
  return <ClipLoader color={colors.primary} {...props} />;
};

export default Loader;
